var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cellar-journal"
  }, [_c("BackgroundVideo"), _vm._m(0), _c("div", {
    staticClass: "cellar-list"
  }, _vm._l(_vm.posts, function (post) {
    return _c("div", {
      key: post.slug,
      staticClass: "cellar-card"
    }, [_c("router-link", {
      attrs: {
        to: {
          name: "cellarJournalDetail",
          params: {
            slug: post.slug
          }
        }
      }
    }, [post.mainImage ? _c("img", {
      staticClass: "cellar-image",
      attrs: {
        src: _vm.urlForImage(post.mainImage).width(1000).url(),
        alt: post.title
      }
    }) : _vm._e()]), _c("div", {
      staticClass: "cellar-card-text"
    }, [_c("router-link", {
      attrs: {
        to: {
          name: "cellarJournalDetail",
          params: {
            slug: post.slug
          }
        }
      }
    }, [_c("h3", [_vm._v(_vm._s(post.title))])]), _c("p", [_vm._v(_vm._s(post.briefDescription))]), _c("router-link", {
      attrs: {
        to: {
          name: "cellarJournalDetail",
          params: {
            slug: post.slug
          }
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var href = _ref.href,
            route = _ref.route,
            navigate = _ref.navigate;
          return [_c("button", {
            staticClass: "cellar-card-button",
            on: {
              click: navigate
            }
          }, [_vm._v(" Discover " + _vm._s(post.shortTitle) + " here ")])];
        }
      }], null, true)
    })], 1)], 1);
  }), 0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cellar-journal-header"
  }, [_c("h1", [_vm._v("The cellar journal")]), _c("p", [_vm._v("Discover the stories, craftsmanship, & traditions that shape the world of fine wine.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };